import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = t(
  (r, a) => /* @__PURE__ */ o.jsx(
    e,
    {
      ref: a,
      ...r,
      image: (s) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...s,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M3 15v-4h11a1 1 0 0 0 .707-1.707L11.414 6l3.293-3.293A1 1 0 0 0 14 1H2a1 1 0 0 0-1 1v13z"
            }
          )
        }
      )
    }
  )
);
i.displayName = "FlagIcon";
export {
  i as FlagIcon,
  i as default
};
//# sourceMappingURL=index.js.map
